import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";

const initialProfileData = {
  client_name: "",
  client_mobile: "",
  billing_name: "",
  first_name: "",
  last_name: "",
  activated_on: "",
  allowed_ip: "",
  exprired_on: "",
  status: "",
  client_email: "",
  whitelistedAt: "",
  id: "",
};

const initialBillingData = {
  whatsapp_setup_charges: "",
  server_charges: "",
  monthly_reccuring_charges: "",
  other_charges: "",
  chats_count: "",
  number_of_chats: "",
  submissionPercentage: "",
  live_chat_charges: "",
  live_chat_agent_charges: "",
  account_type: "",
  received_amount: "",
  receive_amount: "",
  email_alert_limit: "",
  min_balance_limit: "",
  billed_on: "",
  gst: "",
  gst_number: "",
  customer_id: "",
  billing_type: "",
  marketing_pin: "",
  utility_pin: "",
  authentication_pin: "",
  service_pin: "",
  feedback_pin: "",
  response_pin: "",
  marketing_pin_charges: "",
  utility_pin_charges: "",
  authentication_pin_charges: "",
  service_pin_charges: "",
  feedback_pin_charges: "",
  response_pin_charges: "",
  remarks: "",
  remark: "",
};

const useAdminProfileSection = ({ Admin }) => {
  const { id } = useParams();
  const { baseUrl, basicAuth } = useContext(GlobalContext);

  const config = {
    headers: {
      Authorization: basicAuth,
      "Content-Type": "application/json",
    },
  };

  const [activeTab, setActiveTab] = useState("profile");

  const [startDate, setStartDate] = useState(new Date());

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [locationReady, setLocationReady] = useState(false);

  const [user, setUser] = useState({});
  const [clients, setClients] = useState([]);
  const [credentials, setCredentials] = useState({});

  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const [locationError, setLocationError] = useState("");
  const [error, setError] = useState("");

  const [formDataProfile, setFormDataProfile] = useState(initialProfileData);
  const [formData, setFormData] = useState(initialBillingData);

  const [confirmModal, setConfirmModal] = useState({
    open: false,
    type: "",
    title: "",
    message: "",
  });

  const formatDateForInput = (apiDate) => {
    if (!apiDate) return "";

    const dateObj = new Date(apiDate);

    if (Number.isNaN(dateObj.getTime())) return "";

    return dateObj.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser");
      setLocationReady(true);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
        setLocationReady(true);
      },
      (err) => {
        setLocationError(err.message);
        setLocationReady(true);
      }
    );
  }, []);

  useEffect(() => {
    if (credentials) {
      setFormData({
        whatsapp_setup_charges: credentials.whatsapp_setup_charges || "",

        server_charges: credentials.server_charges || "",
        monthly_reccuring_charges:
          credentials.monthly_reccuring_charges || "",
        other_charges: credentials.other_charges || "",

        chats_count: credentials.chats_count || "",
        number_of_chats:
          credentials.number_of_chats || credentials.chats_count || "",

        submissionPercentage: credentials.submissionPercentage || "",

        live_chat_charges: credentials.live_chat_charges || "",
        live_chat_agent_charges:
          credentials.live_chat_agent_charges ||
          credentials.live_chat_charges ||
          "",

        account_type: credentials.account_type || "",

        received_amount: credentials.received_amount || "",
        receive_amount:
          credentials.receive_amount || credentials.received_amount || "",

        email_alert_limit: credentials.email_alert_limit || "",
        min_balance_limit: credentials.min_balance_limit || "",

        billed_on: credentials.billed_on || "",

        gst: credentials.gst || "",
        gst_number: credentials.gst_number || credentials.gst || "",

        customer_id: credentials.customer_id || "",
        billing_type: credentials.billing_type || "",

        marketing_pin: credentials.marketing_pin || "",
        utility_pin: credentials.utility_pin || "",
        authentication_pin: credentials.authentication_pin || "",
        service_pin: credentials.service_pin || "",
        feedback_pin: credentials.feedback_pin || "",
        response_pin: credentials.response_pin || "",

        marketing_pin_charges:
          credentials.marketing_pin_charges || credentials.marketing_pin || "",
        utility_pin_charges:
          credentials.utility_pin_charges || credentials.utility_pin || "",
        authentication_pin_charges:
          credentials.authentication_pin_charges ||
          credentials.authentication_pin ||
          "",
        service_pin_charges:
          credentials.service_pin_charges || credentials.service_pin || "",
        feedback_pin_charges:
          credentials.feedback_pin_charges || credentials.feedback_pin || "",
        response_pin_charges:
          credentials.response_pin_charges || credentials.response_pin || "",

        remarks: credentials.remarks || "",
        remark: credentials.remark || credentials.remarks || "",
      });
    }
  }, [credentials]);

  useEffect(() => {
    if (user) {
      setFormDataProfile({
        client_name: user.client_name || "",
        client_mobile: user.client_mobile || "",
        billing_name: user.billing_name || "",
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        activated_on: formatDateForInput(user.activated_on) || "",
        allowed_ip: user.allowed_ip || "",
        exprired_on: formatDateForInput(user.exprired_on) || "",
        status: user.status || "",
        client_email: user.client_email || "",
        id: user.id || "",
        whitelistedAt: user.whitelistedAt || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const fieldMap = {
      accountType: "account_type",
      billingOn: "billed_on",
      billingType: "billing_type",
      receive_amount: "received_amount",
      gst_number: "gst",
      live_chat_agent_charges: "live_chat_charges",
      number_of_chats: "chats_count",
      remark: "remarks",
    };

    const finalName = fieldMap[name] || name;

    setFormData((prev) => ({
      ...prev,
      [finalName]: value,
      [name]: value,
    }));
  };

  const handleChangeProfile = (e) => {
    const { name, value } = e.target;

    setFormDataProfile((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchSuperAdminClientsCall = async () => {
    if (!Admin?.pkid || !baseUrl || !basicAuth) return;

    setLoading(true);

    try {
      const userDetail = {
        userid: Admin.pkid,
        latitude,
        longitude,
      };

      const response = await axios.post(
        `${baseUrl}/SuperAdmin/getClientList`,
        userDetail,
        config
      );

      if (response.data.responseCode === "00") {
        const apiClients = response.data.response || [];

        setClients(apiClients);

        const selectedUser = apiClients.find(
          (client) => String(client?.id) === String(id)
        );

        if (selectedUser) {
          setUser(selectedUser);
        }
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching clients");
      console.error("Error fetching clients:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchClientCredentials = async () => {
    if (!id || !baseUrl || !basicAuth) return;

    setLoading(true);

    try {
      const userDetail = {
        userid: id,
        latitude,
        longitude,
      };

      const response = await axios.post(
        `${baseUrl}/SuperAdmin/getClientConfigurations`,
        userDetail,
        config
      );

      if (response.data.responseCode === "00") {
        setCredentials(response.data.response || {});
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching client configurations");
      console.error("Error fetching client configurations:", error);
    } finally {
      setLoading(false);
    }
  };

  const editClientsCredentialCall = async (e) => {
    e.preventDefault();

    setConfirmModal({
      open: true,
      type: "credentials",
      title: "Update Credentials?",
      message: "Do you want to change the client credentials?",
    });
  };

  const editClientsDetailsCall = async (e) => {
    e.preventDefault();

    setConfirmModal({
      open: true,
      type: "profile",
      title: "Update User Details?",
      message: "Do you want to change the user details?",
    });
  };

  const submitCredentialUpdate = async () => {
    if (!Admin?.pkid) {
      toast.error("Admin ID missing");
      return;
    }

    try {
      setActionLoading(true);

      const userDetail = {
        userid: Admin.pkid,
        clientId: id,

        serverCharges: formData.server_charges,
        monthlyReccuringCharges: formData.monthly_reccuring_charges,
        otherCharges: formData.other_charges,
        chatsCount: formData.chats_count,
        submissionPercentage: formData.submissionPercentage,
        liveChatCharges: formData.live_chat_charges,

        accountType: formData.account_type,
        receivedAmount: formData.received_amount,
        emailAlertLimit: formData.email_alert_limit,
        minBalanceLimit: formData.min_balance_limit,
        billedOn: formData.billed_on,

        gst: formData.gst,
        customerId: formData.customer_id,
        billingType: formData.billing_type,

        marketingPin: formData.marketing_pin_charges || formData.marketing_pin,
        utilityPin: formData.utility_pin_charges || formData.utility_pin,
        authenticationPin:
          formData.authentication_pin_charges || formData.authentication_pin,
        servicePin: formData.service_pin_charges || formData.service_pin,
        feedbackPin: formData.feedback_pin_charges || formData.feedback_pin,
        responsePin: formData.response_pin_charges || formData.response_pin,

        remarks: formData.remarks,
      };

      const response = await axios.post(
        `${baseUrl}/SuperAdmin/editClientConfigurations`,
        userDetail,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response.data.responseMessage || "Credentials updated successfully"
        );
        closeConfirmModal();
        fetchClientCredentials();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to update credentials"
        );
      }
    } catch (error) {
      toast.error("Error updating credentials");
      console.error("Error updating credentials:", error);
    } finally {
      setActionLoading(false);
    }
  };

  const submitProfileUpdate = async () => {
    try {
      setActionLoading(true);

      const userDetail = {
        userid: formDataProfile.id,
        clientId: formDataProfile.client_name,
        firstName: formDataProfile.first_name,
        lastName: formDataProfile.last_name,
        emailId: formDataProfile.client_email,
        mobileNumber: formDataProfile.client_mobile,
        billingName: formDataProfile.billing_name,
        expiredOn: formDataProfile.exprired_on,
        allowedIp: formDataProfile.allowed_ip,
      };

      const response = await axios.post(
        `${baseUrl}/SuperAdmin/editClientDetails`,
        userDetail,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(
          response.data.responseMessage || "Client details updated successfully"
        );
        closeConfirmModal();
        fetchSuperAdminClientsCall();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to update client details"
        );
      }
    } catch (error) {
      toast.error("Error updating client details");
      console.error("Error updating client details:", error);
    } finally {
      setActionLoading(false);
    }
  };

  const closeConfirmModal = () => {
    setConfirmModal({
      open: false,
      type: "",
      title: "",
      message: "",
    });
  };

  const handleConfirmSubmit = () => {
    if (confirmModal.type === "credentials") {
      submitCredentialUpdate();
      return;
    }

    if (confirmModal.type === "profile") {
      submitProfileUpdate();
    }
  };

  useEffect(() => {
    if (!locationReady) return;

    fetchSuperAdminClientsCall();
    fetchClientCredentials();
  }, [locationReady, id, Admin?.pkid]);

  return {
    id,

    activeTab,
    setActiveTab,

    startDate,
    setStartDate,

    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,

    latitude,
    longitude,
    locationError,
    error,

    user,
    clients,
    credentials,

    loading,
    actionLoading,

    formDataProfile,
    formData,

    handleChange,
    handleChangeProfile,

    editClientsCredentialCall,
    editClientsDetailsCall,

    confirmModal,
    closeConfirmModal,
    handleConfirmSubmit,

    fetchSuperAdminClientsCall,
    fetchClientCredentials,
  };
};

export default useAdminProfileSection;